// Spreadsheet file extensions supported by Document Editor
export const SPREADSHEET_EXTENSIONS = ['xls', 'xlsx', 'csv', 'ods'];

// Document file extensions (Word) - not yet supported by editor
export const DOCUMENT_EXTENSIONS = ['doc', 'docx', 'odt', 'rtf'];

// Presentation file extensions (PowerPoint) - not yet supported by editor
export const PRESENTATION_EXTENSIONS = ['ppt', 'pptx', 'odp'];

// Document Editor modes
export const DOCUMENT_EDITOR_MODES = /** @type {const} */ ({
  VIEW: 'view',
  EDIT: 'edit',
});

// All file types that should be handled by DocumentEditor component (editor or fallback)
export const DOCUMENT_EDITOR_FILE_EXTENSIONS = [
  ...SPREADSHEET_EXTENSIONS,
  ...DOCUMENT_EXTENSIONS,
  ...PRESENTATION_EXTENSIONS,
];
